/**
 * Most trace ids that fit in a newLink URL. nginx caps the request line at 8 KB
 * and a uuid plus separator is 37 bytes; measured against staging, 218 ids still
 * load and 220 return 414. Only the pre-batch path (USE_BATCH_ACTION off) is
 * bound by this — a batch action carries its selection out of band.
 */
export const MAX_URL_TRACE_IDS = 200;
